$(function () {
  import(/* webpackChunkName: "chunk.owl-carousel" */ 'owl.carousel/src/js/owl.carousel').then(() => {
    import(/* webpackChunkName: "chunk.owl-carousel-navigation" */ 'owl.carousel/src/js/owl.navigation').then(() => {
      jQuery('.slider-partners').owlCarousel({
        responsive: {
          568: {
            items: 3,
          },

          768: {
            margin: 20,
            items: 3,
          },
          992: {
            margin: 18,
            items: 3,
          },
          1241: {
            margin: 20,
            items: 3,
          },
        },
        nav: true,
        dots: false,
        items: 2,
        slideBy: 1,
        loop: true,
        margin: 18,
        smartSpeed: 200,
      });
    });
  });
});